import { Box, Container, Typography, Skeleton } from '@mui/material';
import './Home.css';
import BBPoster from "../../Assets/BB-Poster.svg";
import Truck from "../../Assets/Truck.png";
import Bagel from "../../Assets/Bagel.png";
import React, { useState, useEffect, useRef } from "react";

function Home() {
  // Scroll effects
  const [scrollY, setScrollY] = useState(0);
  const [imageTopPos, setImageTopPos] = useState(0);
  const [imageBottomPos, setImageBottomPos] = useState(0);

  const imageRefTop = useRef(null);
  const imageRefBottom = useRef(null);

  const handleScroll = () => setScrollY(window.scrollY);

  const updateImagePositions = () => {
    if (imageRefTop.current) {
      const rect = imageRefTop.current.getBoundingClientRect();
      setImageTopPos(rect.top);
    }
    if (imageRefBottom.current) {
      const rect = imageRefBottom.current.getBoundingClientRect();
      setImageBottomPos(rect.top);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("scroll", updateImagePositions);

    updateImagePositions();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", updateImagePositions);
    };
  }, []);

  // Image loading effects
  const [truckLoaded, setTruckLoaded] = useState(false);
  const [bagelLoaded, setBagelLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = Truck;
    img.onload = () => {
      setTruckLoaded(true);
      handleScroll();
      updateImagePositions();
    };
  }, []);

  useEffect(() => {
    const img = new Image();
    img.src = Bagel;
    img.onload = () => setBagelLoaded(true);
  }, []);

  return (
    <Box>
      <Box sx={{ height: "800px" }}>
        <Box
          sx={{
            position: "absolute",
            top: "260px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: { sm: "80vw", md: "40vw" },
              maxWidth: "560px",
              height: "auto",
              borderRadius: "16px",
              backgroundColor: "var(--bb-brand-color-6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={BBPoster}
              alt="Poster Logo"
              style={{
                width: "100%",
                height: "auto",
              }}
            />
          </Box>
        </Box>
        
        {/*!truckLoaded && ( // TODO - Make this not cause positioning issues on load
          <Skeleton
            variant="rectangular"
            width="100%"
            height="800px"
            animation="wave"
            sx={{ position: "relative", zIndex: -1 }}
          />
        )*/}
        <Box
          sx={{
            position: "relative",
            height: "800px",
            backgroundImage: `url(${Truck})`,
            backgroundSize: "cover",
            backgroundPosition: `center ${Math.max(0, imageTopPos - scrollY) * 0.2}px`,
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            zIndex: -1,
            opacity: truckLoaded ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
          }}
          ref={imageRefTop}
        />
      </Box>

      <Box
        sx={{
          bgcolor: "var(--bb-brand-color-6)",
          height: "400px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container sx={{ textAlign: "center" }}>
          <Typography variant="h4" gutterBottom>
            Your local for bread with holes in
          </Typography>
          <Typography variant="h4" gutterBottom>—</Typography>
          <Typography variant="body1">
            Our vintage-style van serves fresh, filling bites that taste heavenly. Our bagels are piled high with bold flavours and packed to perfection. With every bagel being a feast for the eyes and for the appetite, Baden's does street food right - Fresh, fast and full of flavour.
          </Typography>
        </Container>
      </Box>

      <Box sx={{ height: "800px" }}>
        {!bagelLoaded && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height="800px"
            animation="wave"
            sx={{ position: "relative", zIndex: -1 }}
          />
        )}
        <Box
          sx={{
            position: "relative",
            height: "800px",
            backgroundImage: `url(${Bagel})`,
            backgroundSize: "cover",
            backgroundPosition: `center ${Math.max(0, imageBottomPos - scrollY) * 0.2}px`,
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            zIndex: -1,
            opacity: bagelLoaded ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
          }}
          ref={imageRefBottom}
        />
      </Box>
    </Box>
  );
}

export default Home;
